var map = {
	"./BaliNet.jpg": 4411,
	"./Interior1.jpg": 6777,
	"./Interior2.jpg": 4286,
	"./Interior3.jpg": 7099,
	"./Interior4.jpg": 4264,
	"./Interior5.jpg": 5173,
	"./Interior6.jpg": 4186,
	"./Interior7.jpg": 6839,
	"./Living1.jpg": 4260,
	"./Living2.jpg": 4307,
	"./OpenDeck1.jpg": 4556,
	"./OpenDeck2.jpg": 7355,
	"./OutsideView1.jpg": 9749,
	"./OutsideView2.jpg": 7674,
	"./OutsideView3.jpg": 5415,
	"./SwimmingPool1.jpg": 1642,
	"./SwimmingPool2.jpg": 7365,
	"./bookingBanner.png": 7131,
	"./bookingBn.png": 3285,
	"./gallery1.png": 885,
	"./gallery10.png": 7921,
	"./gallery2.png": 510,
	"./gallery3.png": 6295,
	"./gallery4.png": 6680,
	"./gallery5.png": 8721,
	"./gallery6.png": 8826,
	"./gallery7.png": 8659,
	"./gallery8.png": 8468,
	"./gallery9.png": 1709,
	"./galleryBanner.png": 296,
	"./galleryBanner2.png": 280,
	"./responsive-about-us.png": 4195,
	"./villa1.png": 1395,
	"./villa2.png": 5784,
	"./villa3.png": 6913,
	"./villa4.png": 8430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;